var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _ellipse, _path8, _circle, _ellipse2, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValveActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m231.24 454.87h112.04v57.133h-112.04z",
    fill: "#c0c7cf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m384.28 179.31v-49.103c0-7.354-5.956-13.315-13.304-13.315h-169.2c-7.347 0-13.304 5.962-13.304 13.315v251.08c0 7.354 5.956 13.315 13.304 13.315h169.2c7.347 0 13.304-5.962 13.304-13.315v-145.75z",
    fill: "#f55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m370.97 116.89h-33.996c7.347 0 13.304 5.962 13.304 13.315v251.08c0 7.354-5.956 13.315-13.304 13.315h33.996c7.347 0 13.304-5.962 13.304-13.315v-251.08c0-7.355-5.956-13.316-13.304-13.316z",
    fill: "#faa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m231.24 0h112.04v56.098h-112.04z",
    fill: "#c0c7cf"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m309.28 454.87h33.996v57.133h-33.996z",
    fill: "#b1b7bf"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m309.28 0h33.996v56.098h-33.996z",
    fill: "#b1b7bf"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m361.6 104.56v-36.51c0-6.603-5.352-11.955-11.955-11.955h-124.94c-6.603 0-11.955 5.352-11.955 11.955v36.511c0 6.603 5.352 12.329 11.955 12.329h124.94c6.603 0 11.956-5.727 11.956-12.33z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.35 56.098h53.642v60.795h-53.642z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.6 442.91v-36.511c0-6.603-5.352-11.955-11.955-11.955h-124.94c-6.603 0-11.955 5.352-11.955 11.955v36.511c0 6.603 5.352 11.955 11.955 11.955h124.94c6.603 0 11.956-5.353 11.956-11.955z",
    fill: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.35 394.45h53.642v60.421h-53.642z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.47 310.12h-20.465c-8.578 0-15.532-6.954-15.532-15.532v-74.499c0-8.578 6.954-15.532 15.532-15.532h20.465z",
    fill: "#8f8f8f"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m111.06 244.14h41.408v26.391h-41.408z",
    fill: "#c0c7cf"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.04,
    cy: 257.34,
    rx: 59.04,
    ry: 59.092,
    fill: "#ffe582"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m59.613 265.636c-1.977 0-3.953-.754-5.461-2.261-3.019-3.016-3.021-7.908-.005-10.927l19.489-19.506c3.017-3.02 7.909-3.021 10.927-.005 3.019 3.016 3.021 7.908.005 10.927l-19.489 19.506c-1.509 1.51-3.488 2.266-5.466 2.266z",
    fill: "#878b91"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 284.65,
    cy: 257.34,
    r: 56.145,
    fill: "#878b91"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 284.88,
    cy: 257.34,
    rx: 24.075,
    ry: 24.096,
    fill: "#052"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m274.23 235.32 202.9-101.85c11.885-5.966 26.352-1.159 32.312 10.737 5.961 11.896 1.158 26.375-10.727 32.341l-202.9 101.85z",
    fill: "#00d455"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m486.27 163.71c9.943 0 9.96-15.453 0-15.453-9.943 0-9.96 15.453 0 15.453z",
    fill: "#878b91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValveActive);
export default __webpack_public_path__ + "static/media/valve_active.7a2ef4e70c5597052f3ddb78ec6e689b.svg";
export { ForwardRef as ReactComponent };